import { useState, useEffect, useRef } from "react";
import "./header.scss";
import { Link, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { Helmet } from "react-helmet";
import TimeAgo from "./time";
import axios from "axios";
import OfferModal from "../../pages/offerModal/offerModal";
import SpecialOfferModal from "../../pages/specialofferModal/specialoffer";
import offerimg from "../../assets/images/offer.png";
import Spinner from "../LoadingSpinner/loadingSpinner";
import emptyImg from "../../assets/images/empty_noti.png";
import profileImg from "../../assets/images/faces/18.jpg";
import logo from "../../assets/images/logo.png";
import frFlag from "../../assets/images/flags/us_flag.jpg";
import enFlag from "../../assets/images/flags/french_flag.jpg";
import Cookies from "js-cookie";
import api from "../../api";
import Expert from "../../components/expert/rightcard";
import { Tooltip } from "react-tooltip";
import { getOrCreateSession } from "../../sessionManager";

const baseUrl = process.env.REACT_APP_BASE_URL;
const Header = ({ data }) => {
  const [cookieLang, setCookieLang] = useState("");
  const [introOffer, setIntroOffer] = useState(null);
  const [offers, setOffers] = useState([]);
  const [selectedOffer, setSelectedOffer] = useState(null);

  const [showOfferModal, setShowOfferModal] = useState(false);
  const [showSpecialofferModal, setShowSpecialOfferModal] = useState(true);
  const [loading, setLoading] = useState(false);
  const [openOfferId, setOpenOfferId] = useState(null);

  function setLanguage(lang) {
    document.cookie = `lang=${lang}; path=/; max-age=31536000`;
    localStorage.setItem("lang", lang);
    window.location.reload();
  }
  const [pseudo, setUserName] = useState("");
  const [personalCode, setPersonalCode] = useState("");
  const location = useLocation();
  const [activeItem, setActiveItem] = useState(location.pathname);
  const [isOpen, setIsOpen] = useState(false);
  const [creditsData, setCreditsData] = useState([]);
  const [message, setMessages] = useState([]);
  const [openOffers, setOpenOffers] = useState({});

  useEffect(() => {
    setActiveItem(location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    const loadUser = () => {
      const token = localStorage.getItem(process.env.REACT_APP_LOCAL_TOKEN);
      const token_horoscope = localStorage.getItem(
        process.env.REACT_APP_LOCAL_TOKEN_HOROSCOPE,
      );

      if (!token && !token_horoscope) return;

      const userInfoCookie = localStorage.getItem(
        process.env.REACT_APP_USER_INFO,
      );

      const horoscopeCookie = localStorage.getItem(
        process.env.REACT_APP_USER_INFO_HOROSCOPE,
      );

      const data = userInfoCookie
        ? JSON.parse(userInfoCookie)
        : horoscopeCookie
          ? JSON.parse(horoscopeCookie)
          : null;

      if (!data) return;

      if (data.personal_code) setPersonalCode(data.personal_code);
      if (data.nickname) setUserName(data.nickname);
    };

    loadUser();

    window.addEventListener("user_updated", loadUser);

    return () => {
      window.removeEventListener("user_updated", loadUser);
    };
  }, []);

  const handleItemClick = (path) => {
    setActiveItem(path);
    if (window.innerWidth < 992) {
      setIsOpen(false);
      document.documentElement.setAttribute("data-toggled", "close");
    }
  };

  const toggleSidebar = (e) => {
    e.preventDefault();
    const newState = !isOpen;
    setIsOpen(newState);
    document.documentElement.setAttribute(
      "data-toggled",
      newState ? "open" : "close",
    );
  };

  const LogOut = async () => {
    try {
      const now = new Date().toISOString();
      await trackInteraction(
        "logout",
        "dropdown_btn",
        "dropdown_btn",
        now,
        now,
      );
      setLoading(true);
      const response = await api.post(`/accounts/sign-out`, {});

      function deleteCookie(name) {
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`;
      }

      localStorage.removeItem(`${process.env.REACT_APP_USER_INFO}`);
      deleteCookie(`${process.env.REACT_APP_SESSION_ID}`);
      deleteCookie(`${process.env.REACT_APP_LEAD_ID}`);
      localStorage.removeItem(`${process.env.REACT_APP_USER_INFO_HOROSCOPE}`);

      localStorage.removeItem(`${process.env.REACT_APP_LOCAL_STORAGE}`);
      localStorage.removeItem(`${process.env.REACT_APP_LOCAL_TOKEN}`);
      localStorage.removeItem(`${process.env.REACT_APP_LOCAL_TOKEN_HOROSCOPE}`);
      localStorage.removeItem(`${process.env.REACT_APP_REFRESH_TOKEN}`);
      localStorage.removeItem(
        `${process.env.REACT_APP_REFRESH_TOKEN_HOROSCOPE}`,
      );

      window.location.href = "/portal/signin";
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  useEffect(() => {
    const handleRefresh = () => {
      fetchOffer(); // your existing function
    };

    window.addEventListener("refresh-header", handleRefresh);

    return () => {
      window.removeEventListener("refresh-header", handleRefresh);
    };
  }, []);
  useEffect(() => {
    function handleClickOutside(event) {
      const sidebarElement = document.querySelector(".main-sidebar");
      if (sidebarElement && !sidebarElement.contains(event.target)) {
        setIsOpen(false);
        document.documentElement.setAttribute("data-toggled", "close");
      }
    }

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  useEffect(() => {
    const scripts = [];
    const loadScripts = () => {
      scripts.forEach((scriptSrc) => {
        const script = document.createElement("script");
        script.src = scriptSrc;
        script.async = true;
        document.body.appendChild(script);
      });
    };
    loadScripts();
    return () => {
      scripts.forEach((scriptSrc) => {
        const script = document.querySelector(`script[src="${scriptSrc}"]`);
        if (script) {
          document.body.removeChild(script);
        }
      });
    };
  }, []);

  const [languageData, setLanguageData] = useState(null);

  useEffect(() => {
    const defaultLang = process.env.REACT_APP_LANG;
    const cookieLang =
      localStorage.getItem("lang") ||
      document.cookie
        .split("; ")
        .find((row) => row.startsWith("lang="))
        ?.split("=")[1] ||
      defaultLang;

    if (cookieLang) {
      setCookieLang(cookieLang);
      import(`../../lang/general/${cookieLang}.json`)
        .then((data) => {
          setLanguageData(data.default);
        })
        .catch((error) => {
          console.error("Error loading language file:", error);
        });
    } else {
      console.error("Language cookie 'lang' not found.");
    }
  }, []);

  const fetchOffer = async () => {
    try {
      const response = await api.get(
        `/content/load?types[]=credits&types[]=introductory_offer&types[]=offers&types[]=last_messages`,
      );
      const credits = response.data?.data?.credits || [];
      const intro = response.data?.data?.introductory_offer || null;
      const offers = response.data?.data?.offers || [];
      const messages = response.data?.data?.last_messages || [];

      setCreditsData(credits);
      setIntroOffer(intro);
      setOffers(offers);
      if (intro) setShowOfferModal(true);
      if (offers?.length > 0) {
        setOpenOfferId(offers[0].id);
      }
      setMessages(messages);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchOffer();
  }, []);

  const offerCredits = creditsData.filter((item) => item.source !== "order");
  const orderCredits = creditsData.filter((item) => item.source === "order");
  const communicationType = orderCredits[0]?.communication_type;

  const buyTooltip =
    communicationType === "call"
      ? languageData.body.header.buy_tooltip_call
      : communicationType === "email"
        ? languageData.body.header.buy_tooltip_email
        : communicationType === "chat"
          ? languageData.body.header.buy_tooltip_chat
          : "";
  /*  const introServices =
    introOffer?.rewards?.flatMap((reward) =>
      reward.packages?.flatMap((pkg) =>
        pkg.items?.map((item) => item.service?.communication),
      ),
    ) || []; */
  const introServices = [
    ...new Set(
      introOffer?.rewards?.flatMap((reward) =>
        reward.packages?.flatMap((pkg) =>
          pkg.items?.map((item) => item.service?.communication),
        ),
      ) || [],
    ),
  ];
  const currentOffer = selectedOffer || offers?.[0];
  const getServiceOfferLabel = (service) => {
    if (service === "call") return languageData.body.by_credit;
    if (service === "email") return languageData.body.by_email;
    if (service === "chat") return languageData.body.by_chat;
    return service;
  };

  const tooltipRef = useRef(null);

  useEffect(() => {
    if (tooltipRef.current) {
      new Tooltip(tooltipRef.current);
    }
  }, []);
  const specialOfferServices =
    currentOffer?.items?.flatMap((item) =>
      item.packages?.flatMap((pkg) =>
        pkg.items?.map((it) => it.service?.communication),
      ),
    ) || [];

  const getServiceSpecialOfferLabel = (service) => {
    if (service === "call") {
      return languageData.body.by_credit;
    }

    return service;
  };

  const openOffer = (id) => {
    setOpenOffers((prev) => ({ ...prev, [id]: true }));
  };

  const closeOffer = (id) => {
    setOpenOffers((prev) => ({ ...prev, [id]: false }));
  };
  useEffect(() => {
    const initialState = {};
    offers?.forEach((offer) => {
      initialState[offer.id] = true;
    });
    setOpenOffers(initialState);
  }, [offers]);

  const handleCloseOffer = (offerId) => {
    setOpenOffers((prev) => ({
      ...prev,
      [offerId]: false,
    }));
  };

  const handleRejectOffer = (offer) => {
    if (offer?.id) {
      Cookies.set(`disableSpecialOfferAutoOpen_${offer.id}`, "1");
    }

    handleCloseOffer(offer.id);
  };
  useEffect(() => {
    if (!offers?.length) return;

    const initialState = {};

    offers.forEach((offer) => {
      const disabled = Cookies.get(`disableSpecialOfferAutoOpen_${offer.id}`);

      if (disabled === "1") return;

      initialState[offer.id] = true;
    });

    setOpenOffers(initialState);
  }, [offers]);
  /*   const getSessionId = async (payload) => {
    let sessionId = Cookies.get(process.env.REACT_APP_SESSION_ID);

    const expiredSession = Cookies.get(
      `${process.env.REACT_APP_SESSION_ID}_expires`,
    );

    const isExpired =
      !expiredSession || Date.now() - Number(expiredSession) > 3600000;

    if (!sessionId || isExpired) {
      const leadId =
        Cookies.get(process.env.REACT_APP_LEAD_ID_PLATFORM) ||
        Cookies.get(process.env.REACT_APP_LEAD_ID);

      const response = await updateSessionLead(leadId, payload);

      if (!response) return null;

      sessionId = String(response.data.data.id);
    }

    return sessionId;
  }; */

  const trackInteraction = async (
    action,
    element,
    element_value,
    time_start = new Date().toISOString(),
    time_end = new Date().toISOString(),
    payload = null,
  ) => {
    try {
      //  const sessionId = await getSessionId(payload);
      const payload = await init();
      const sessionId = await getOrCreateSession(payload);
      if (!sessionId) return;

      await api.post(
        `${process.env.REACT_APP_BASE_URL}/tracking/interactions/add`,
        {
          session_id: sessionId,
          action,
          element,
          ...(element_value ? { element_value: element_value } : {}),
          //element_value: element_value || "",
          time_start,
          time_end,
        },
      );
    } catch (error) {
      console.error("Tracking error:", error);
    }
  };

  const getDevice = () => {
    const ua = navigator.userAgent;

    if (/mobile/i.test(ua)) return "Mobile";
    if (/tablet/i.test(ua)) return "Tablet";
    return "Desktop";
  };
  const getBrowserInfo = () => {
    const ua = navigator.userAgent;
    let browser = "Unknown";
    let version = "Unknown";

    if (ua.includes("Chrome")) {
      browser = "Chrome";
      version = ua.match(/Chrome\/([\d.]+)/)?.[1];
    } else if (ua.includes("Firefox")) {
      browser = "Firefox";
      version = ua.match(/Firefox\/([\d.]+)/)?.[1];
    } else if (ua.includes("Safari")) {
      browser = "Safari";
      version = ua.match(/Version\/([\d.]+)/)?.[1];
    } else if (ua.includes("Edg")) {
      browser = "Edge";
      version = ua.match(/Edg\/([\d.]+)/)?.[1];
    }

    return { browser, version };
  };
  const getOSInfo = () => {
    const ua = navigator.userAgent;
    let os = "Unknown";
    let version = "Unknown";

    if (ua.includes("Windows")) {
      os = "Windows";
      version = ua.match(/Windows NT ([\d.]+)/)?.[1];
    } else if (ua.includes("Mac OS")) {
      os = "OS X";
      version = ua.match(/Mac OS X ([\d_]+)/)?.[1]?.replace(/_/g, ".");
    } else if (ua.includes("Android")) {
      os = "Android";
      version = ua.match(/Android ([\d.]+)/)?.[1];
    } else if (ua.includes("iPhone")) {
      os = "iOS";
      version = ua.match(/OS ([\d_]+)/)?.[1]?.replace(/_/g, ".");
    }

    return { os, version };
  };

  async function getUserCountryOnce() {
    const cached = localStorage.getItem("userCountry");
    if (cached) return JSON.parse(cached);

    try {
      const ipRes = await fetch("https://api.ipify.org?format=json");
      const ipData = await ipRes.json();

      const lookupRes = await fetch(
        "https://builder.leadsy.pro/lookup_api/v1/" + ipData.ip,
      );

      const lookupData = await lookupRes.json();
      const data = lookupData?.data || {};

      const result = {
        ip: data.ip || ipData.ip,
        city: data.city || "Unknown City",
        region: data.region || "Unknown Region",
        country: data.country || "Unknown",
        timezone:
          data.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone,
      };
      const country = lookupData?.data?.country || "us";
      localStorage.setItem("userCountry", JSON.stringify(result));

      return result;
    } catch (e) {
      return {
        ip: "",
        city: "Unknown City",
        region: "Unknown Region",
        country: "US",
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      };
    }
  }
  const { browser, version } = getBrowserInfo();
  const { os, version: osVersion } = getOSInfo();
  const init = async () => {
    const locationData = await getUserCountryOnce();
    const payload = {
      url: window.location.href,
      device: getDevice(),
      ip_address: locationData.ip,
      browser_data: navigator.userAgent,
      details: {
        browser: browser,
        browser_version: version,
        operating_system: os,
        operating_system_version: osVersion,
        location: `${locationData.region}`,
        city: locationData.city,
        region: locationData.region,
        country: locationData.country,
        timezone: locationData.timezone,
        use_vpn: false,
      },
    };
    return payload;
  };
  async function updateSessionLead(lead_id, payload) {
    try {
      const response = await api.post(
        `${process.env.REACT_APP_BASE_URL}/tracking/sessions/add`,
        {
          ...payload,
          lead_id: lead_id,
        },
      );
      const data = response.data;
      Cookies.set(`${process.env.REACT_APP_SESSION_ID}`, String(data.data.id));
      Cookies.set(
        `${process.env.REACT_APP_LEAD_ID}`,
        String(data.data.lead_id),
      );
      Cookies.set(
        `${process.env.REACT_APP_SESSION_ID}_expires`,
        String(Date.now()),
      );
      return response;
    } catch (err) {
      console.error("Update session error:", err);
      return null;
    }
  }
  const formatTime = (seconds) => {
    const hrs = String(Math.floor(seconds / 3600)).padStart(2, "0");
    const mins = String(Math.floor((seconds % 3600) / 60)).padStart(2, "0");
    const secs = String(seconds % 60).padStart(2, "0");

    return `${hrs}:${mins}:${secs}`;
  };

  useEffect(() => {
    const token = localStorage.getItem(process.env.REACT_APP_LOCAL_TOKEN);

    if (!token) return;
    const runTracking = async () => {
      /* const payload = await init();
      await getSessionId(payload); */
      const payload = await init();
      await getOrCreateSession(payload);
      await trackInteraction(
        "view",
        "page_load",
        window.location.href,
        new Date().toISOString(),
        new Date().toISOString(),
        payload,
      );
    };

    runTracking();
  }, []);

  useEffect(() => {
    const handleSubmit = async (e) => {
      const form = e.target;
      const now = new Date().toISOString();
      await trackInteraction("submit", form.name, now, now);
    };

    const handleClick = async (e) => {
      const element = e.target.closest("[data-interaction]");
      if (!element) return;
      if (
        element.dataset.interaction === "time" ||
        element.dataset.interaction === "date"
      ) {
        return;
      }

      const elementTag = element.dataset.interaction;

      const now = new Date().toISOString();

      let elementValue = "";

      if (element.dataset.expert) {
        elementValue = element.dataset.expert;
      } else {
        elementValue =
          element.textContent.trim() ||
          element.querySelector("img")?.alt ||
          element.getAttribute("href") ||
          "";
      }

      await trackInteraction(
        "click",
        elementTag,
        elementValue || null,
        now,
        now,
      );
      /*   const button = e.target.closest("button, a");
  if (!button) return;

  const elementTag = button.dataset.interaction;
  if (!elementTag) return;

  const now = new Date().toISOString();

  let elementValue = "";

  if (button.dataset.expert) {
    elementValue = button.dataset.expert;
  } else {
    elementValue =
      button.textContent.trim() ||
      button.querySelector("img")?.alt ||
      button.getAttribute("href") ||
      "";
  }

  await trackInteraction(
    "click",
    elementTag,
    elementValue,
    now,
    now
  ); */
    };

    const handleBlur = async (e) => {
      if (!["INPUT", "SELECT", "TEXTAREA"].includes(e.target.tagName)) return;
      if (!e.target.name) return;
      if (e.target.id?.startsWith("react-select-")) return;
      const now = new Date().toISOString();
      const value = e.target.value;
      if (e.target.dataset.interaction && !value) {
        return;
      }
      await trackInteraction("input", e.target.name, e.target.value, now, now);
    };

    document.addEventListener("submit", handleSubmit);
    document.addEventListener("click", handleClick);
    document.addEventListener("blur", handleBlur, true);

    return () => {
      document.removeEventListener("submit", handleSubmit);
      document.removeEventListener("click", handleClick);
      document.removeEventListener("blur", handleBlur, true);
    };
  }, []);
  const languageConfig = {
    fr: {
      flag: frFlag,
    },
    en: {
      flag: enFlag,
    },
  };
  const availableLanguages = process.env.REACT_APP_LANGUAGES.split(",")
    .map((lang) => lang.trim())
    .filter(Boolean);

  if (!languageData) {
    return <div></div>;
  }

  return (
    <>
      <Helmet>
        <html
          lang={cookieLang}
          dir="ltr"
          data-nav-layout="horizontal"
          data-theme-mode="light"
          data-menu-styles="light"
          loader="enable"
          data-nav-style="menu-click"
          data-default-header-styles="divinaro"
          data-page-style="regular"
          data-menu-position="fixed"
          data-header-position="fixed"
          className="Divinaro"
          data-toggled={isOpen ? "open" : "close"}
        />
      </Helmet>
      <header className="app-header">
        <div className="main-header-container container">
          <div className="header-content-left">
            <div className="header-element">
              <a
                data-interaction=""
                aria-label="anchor"
                href="#"
                className="sidemenu-toggle header-link"
                onClick={toggleSidebar}
              >
                <span className="open-toggle me-2">
                  <i className="bx bx-menu header-link-icon"></i>
                </span>
              </a>
            </div>
            <div className="header-element">
              <div className="horizontal-logo d-flex align-items-center">
                <Link
                  data-interaction="logo_home"
                  to={`/`}
                  className="header-logo"
                >
                  <img src={logo} alt="logo" className="desktop-logo" />
                  <img src={logo} alt="logo" className="toggle-logo" />
                </Link>
              </div>
            </div>
          </div>

          <div className="header-content-right">
            <div className="header-element mainuserProfile d-none d-sm-flex">
              {introOffer && (
                <div className="header-link dropdown-toggle gap-11">
                  <a
                    data-interaction="open_introductory_modal_button"
                    className="flex align-items-center gap-10 pointer mx-half"
                    onClick={() => setShowOfferModal(true)}
                  >
                    <img className="offerimg" src={offerimg} alt="offer" />
                    <span className="offerBtn">
                      {languageData.body.header.discover_offer}
                    </span>
                  </a>
                </div>
              )}

              {offerCredits.map((item, index) => (
                <div className=" align-items-center m-0" key={item.id || index}>
                  <div className="d-sm-flex wd-100p">
                    <div className="my-auto d-none d-xl-flex">
                      <Link
                        data-interaction="offer_header"
                        key={index}
                        className={`${
                          Number(item.credit) > 0
                        } offer_credit align-items-center`}
                        data-tooltip-id={`offercredit-${index}`}
                        data-tooltip-content={
                          languageData.body.header.offer_tooltip[
                            item.communication_type
                          ]
                        }
                        data-tooltip-place="bottom"
                      >
                        <Tooltip id={`offercredit-${index}`} />
                        <i class="bi bi-gift-fill p-custom"></i>
                        <span
                          className="credit_header p-custom gap-2"
                          data-bs-toggle="tooltip"
                          data-bs-placement="bottom"
                        >
                          {item.communication_type === "call" ? (
                            <i class="bi bi-telephone-fill"></i>
                          ) : (
                            <i class="bi bi-chat-fill"></i>
                          )}

                          {item.unit === "period"
                            ? formatTime(Number(item.credit))
                            : item.credit || 0}
                        </span>
                      </Link>
                    </div>
                  </div>
                </div>
              ))}

              {orderCredits.length === 1 && (
                <Link
                  data-interaction="plans_menu"
                  to={`/plans`}
                  data-tooltip-id="buy_tooltip1"
                  data-tooltip-content={buyTooltip}
                  data-tooltip-place="bottom"
                  className={`m-custom btn ${
                    Number(orderCredits[0]?.credit) > 0
                      ? "btn-success"
                      : "btn-danger"
                  } label-btn label-end btn-sm flex align-items-center`}
                >
                  {" "}
                  <Tooltip id="buy_tooltip1" />
                  <span className="fw-bold fs-13 mb-0 label-btn-icon">
                    {orderCredits[0]?.unit === "period"
                      ? formatTime(Number(orderCredits[0]?.credit))
                      : Number(orderCredits[0]?.credit) > 0
                        ? `${orderCredits[0]?.credit}`
                        : "0"}
                  </span>
                  {orderCredits[0].communication_type === "call" ? (
                    <i class="bi bi-telephone-fill"></i>
                  ) : (
                    <i class="bi bi-chat-fill"></i>
                  )}{" "}
                  {languageData.body.header.buy}
                </Link>
              )}
              {orderCredits.length > 1 &&
                orderCredits.map((item, index) => {
                  const tooltipText =
                    item.communication_type === "call"
                      ? languageData.body.header.buy_tooltip_call
                      : languageData.body.header.buy_tooltip_chat;
                  return (
                    <div
                      className=" align-items-center m-custom"
                      key={item.id || index}
                    >
                      <div className="d-sm-flex wd-100p">
                        <div className="my-auto d-none d-xl-flex">
                          <Link
                            data-interaction="credit_header"
                            to={`/plans`}
                            data-tooltip-id={`buy_tooltip_${index}`}
                            data-tooltip-content={tooltipText}
                            data-tooltip-place="bottom"
                            className="btn-remaining"
                          >
                            <Tooltip id={`buy_tooltip_${index}`} />
                            {item.communication_type === "call" ? (
                              <i class="bi bi-telephone-fill"></i>
                            ) : (
                              <i class="bi bi-chat-fill"></i>
                            )}
                            <span className="credit_header">
                              {item.unit === "period"
                                ? formatTime(Number(item.credit))
                                : `${item.credit}`}
                            </span>
                          </Link>
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
            <div className="header-element mainuserProfile">
              <a
                data-interaction="personal_code"
                href="#"
                className="header-link dropdown-toggle"
                id="mainHeaderProfile"
                data-tooltip-id="personal_code_tooltip"
                data-tooltip-content={
                  languageData.body.header.personal_code_tooltip
                }
                data-tooltip-place="bottom"
              >
                <Tooltip id="personal_code_tooltip" />
                <div className="d-flex align-items-center">
                  <div className="d-sm-flex wd-100p">
                    <div className="my-auto d-none d-xl-flex">
                      <div className="flex-fill text-dark">
                        <p className="fw-bold fs-14 mb-0">{personalCode}</p>

                        <p className="mb-0 fs-11 op-7">
                          {languageData.body.header.personal_code}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            </div>
            <div className="header-element mainuserProfile">
              <a
                data-interaction="profile_dropdown"
                href="#"
                className="header-link dropdown-toggle"
                id="mainHeaderProfile"
                data-bs-toggle="dropdown"
                data-bs-auto-close="outside"
                aria-expanded="false"
                data-tooltip-id="profile_tooltip"
                data-tooltip-content={languageData.body.header.profile_tooltip}
                data-tooltip-place="bottom"
              >
                <Tooltip id="profile_tooltip" />
                <div className="d-flex align-items-center">
                  <div className="d-sm-flex wd-100p">
                    {/*  <span className="avatar avatar-rounded avatar-sm bg-dark"><img src={profileImg} alt={pseudo} /></span>
                     */}

                    <span className="avatar avatar-rounded avatar-sm bg-white black">
                      {pseudo?.charAt(0).toUpperCase()}
                    </span>

                    <div className="ms-2 my-auto d-none d-xl-flex">
                      <h6 className="font-weight-semibold mb-0 fs-13 user-name d-sm-block d-none">
                        {pseudo}
                      </h6>
                    </div>
                  </div>
                </div>
              </a>
              <ul
                className="dropdown-menu border-0 main-header-dropdown overflow-hidden header-profile-dropdown"
                aria-labelledby="mainHeaderProfile"
              >
                <li>
                  <Link
                    data-interaction="profile_button"
                    className="dropdown-item border-bottom"
                    to={`/profile`}
                  >
                    <i className="fs-13 me-2 bx bx-user orange_color"></i>
                    {languageData.body.header.profile}
                  </Link>
                </li>
                <li>
                  <Link
                    data-interaction="faq_button"
                    className="dropdown-item border-bottom"
                    to={`/faq`}
                  >
                    <i className="fs-13 me-2 bx bx-help-circle orange_color"></i>
                    {languageData.body.header.faq}
                  </Link>
                </li>

                <li>
                  <a className="dropdown-item " onClick={LogOut}>
                    <i className="fs-13 me-2 bx bx-arrow-to-right orange_color"></i>
                    {languageData.body.header.logout}
                  </a>
                </li>
              </ul>
            </div>
            <div className="header-element">
              <Link
                data-interaction="wishlist_button"
                to={`/wishlist`}
                className="header-link dropdown-toggle"
                data-tooltip-id="favorite_tooltip"
                data-tooltip-content={languageData.body.header.wishlist}
                data-tooltip-place="bottom"
              >
                <i className="bx bx-heart bx-flip-horizontal header-link-icon ionicon"></i>
              </Link>
              <Tooltip id="favorite_tooltip" />
            </div>
            {availableLanguages.length > 1 && (
              <div className="header-element country-selector">
                <a
                  data-interaction="languages_button"
                  aria-label="anchor"
                  href="javascript:void(0);"
                  className="header-link dropdown-toggle"
                  data-bs-toggle="dropdown"
                  data-bs-auto-close="outside"
                  data-tooltip-id="lang_tooltip"
                  data-tooltip-content={languageData.body.header.language}
                  data-tooltip-place="bottom"
                >
                  <i className="bx bx-globe header-link-icon"></i>
                </a>
                <Tooltip id="lang_tooltip" />
                <ul
                  className="dropdown-position absolute main-header-dropdown dropdown-menu border-0 dropdown-menu-end"
                  data-popper-placement="none"
                >
                  {availableLanguages.map((lang) => {
                    const config = languageConfig[lang];

                    if (!config) return null;

                    return (
                      <li key={lang}>
                        <a
                          href="#"
                          data-interaction="lang"
                          className="dropdown-item d-flex align-items-center"
                          onClick={(e) => {
                            e.preventDefault();
                            setLanguage(lang);
                          }}
                        >
                          <span className="avatar avatar-xs lh-1 me-2">
                            <img src={config.flag} alt={lang} />
                          </span>

                          {languageData.body.lang[lang]}
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </div>
            )}
            <div className="header-element notifications-dropdown">
              <a
                data-interaction="notifications_button"
                className="header-link dropdown-toggle"
                data-bs-toggle="dropdown"
                data-bs-auto-close="outside"
                data-tooltip-id="noti_tooltip"
                data-tooltip-content={
                  languageData.body.header.notifications.title
                }
                data-tooltip-place="bottom"
                id="messageDropdown"
                aria-expanded="false"
              >
                <i className="bx bx-bell bx-flip-horizontal header-link-icon ionicon"></i>
                {message?.length > 0 && (
                  <span
                    className="badge bg-info rounded-pill header-icon-badge pulse pulse-secondary"
                    id="notification-icon-badge"
                  >
                    {message.length}
                  </span>
                )}
              </a>
              <Tooltip id="noti_tooltip" />
              <div className="absolute dropdown-position main-header-dropdown dropdown-menu border-0 dropdown-menu-end">
                <div className="p-3">
                  <div className="d-flex align-items-center justify-content-between">
                    <p className="mb-0 fs-17 fw-semibold">
                      {languageData.body.header.notifications.title}
                    </p>
                  </div>
                </div>
                <div className="dropdown-divider"></div>
                {message?.length > 0 ? (
                  <a
                    data-interaction="notifications_message"
                    class="dd-item"
                    href={`/portal/messages?conversation=${message[0].id}`}
                  >
                    <div class="dd-icon ic-msg">
                      <i class="ti ti-message"></i>
                    </div>
                    <div class="dd-body">
                      <div class="dd-text">
                        <strong>
                          {languageData.body.header.notifications.new_message}
                        </strong>{" "}
                        —{" "}
                        {
                          languageData.body.header.notifications
                            .have_notification
                        }
                      </div>
                      <span class="dd-unread-dot"></span>
                    </div>
                  </a>
                ) : (
                  <div class="empty">
                    <div class="empty-icon-wrap">
                      <svg
                        width="30"
                        height="30"
                        viewBox="0 0 30 30"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                      >
                        <rect
                          x="4"
                          y="7"
                          width="22"
                          height="16"
                          rx="3"
                          fill="#EBF2FD"
                          stroke="#2563EB"
                          stroke-width="1.4"
                        ></rect>
                        <path
                          d="M4 10l11 7 11-7"
                          stroke="#2563EB"
                          stroke-width="1.4"
                          stroke-linecap="round"
                        ></path>
                      </svg>
                    </div>
                    <div class="empty-title">
                      {" "}
                      {languageData.body.header.notifications.empty_message}
                    </div>
                    <div class="empty-sub">
                      {" "}
                      {
                        languageData.body.header.notifications
                          .empty_notification
                      }
                    </div>
                  </div>
                )}
                <div className="p-5 empty-item1 d-none">
                  <div className="text-center">
                    <span className="avatar avatar-xl avatar-rounded bg-secondary-transparent">
                      <i className="bx bx-bell-off bx-tada fs-2"></i>
                    </span>
                    <h6 className="fw-semibold mt-3">
                      {languageData.body.header.notifications.no}
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <aside className="app-sidebar" id="sidebar">
        <div className="main-sidebar-header">
          <a href="/" className="header-logo" data-interaction="logo_header">
            <img src={logo} alt="logo" className="desktop-logo" />
            <img src={logo} alt="logo" className="toggle-logo" />
          </a>
        </div>
        <div className="main-sidebar" id="sidebar-scroll" data-simplebar="init">
          <div className="simplebar-content-wrapper">
            <nav className="main-menu-container nav nav-pills flex-column sub-open align-items-center w-100">
              <ul className="main-menu ml-0 mr-0">
                <li
                  className={`slide ${activeItem === "/experts" ? "active" : ""}`}
                >
                  <Link
                    data-interaction="expert_menu"
                    to={"/experts"}
                    className={`side-menu__item ${
                      activeItem === "/experts" ? "active" : ""
                    }`}
                    onClick={() => handleItemClick("/experts")}
                  >
                    <span className="side-menu__icon">
                      <i className="ri-group-line"></i>
                    </span>
                    <span className="side-menu__label">
                      {languageData.body.menu.experts}
                    </span>
                  </Link>
                </li>

                <li
                  className={`slide ${
                    activeItem === "/consultations" ? "active" : ""
                  }`}
                >
                  <Link
                    data-interaction="consultations_menu"
                    to={"/consultations"}
                    className={`side-menu__item ${
                      activeItem === "/consultations" ? "active" : ""
                    }`}
                    onClick={() => handleItemClick("/consultations")}
                  >
                    <span className="side-menu__icon">
                      <i className="bx bx-spa"></i>
                    </span>
                    <span className="side-menu__label">
                      {languageData.body.menu.consultations}
                    </span>
                  </Link>
                </li>

                {/* Similar pattern for other menu items */}
                <li
                  className={`slide ${
                    activeItem === "/payments" ? "active" : ""
                  }`}
                >
                  <Link
                    data-interaction="payments_menu"
                    to={"/payments"}
                    className={`side-menu__item ${
                      activeItem === "/payments" ? "active" : ""
                    }`}
                    onClick={() => handleItemClick("/payments")}
                  >
                    <span className="side-menu__icon">
                      <i className="bx bx-money"></i>
                    </span>
                    <span className="side-menu__label">
                      {languageData.body.menu.payments}
                    </span>
                  </Link>
                </li>

                <li
                  className={`slide ${
                    activeItem === "/comments" ? "active" : ""
                  }`}
                >
                  <Link
                    data-interaction="comments_menu"
                    to={"/comments"}
                    className={`side-menu__item ${
                      activeItem === "/comments" ? "active" : ""
                    }`}
                    onClick={() => handleItemClick("/comments")}
                  >
                    <span className="side-menu__icon">
                      <i className="ri-chat-heart-line"></i>
                    </span>
                    <span className="side-menu__label">
                      {languageData.body.menu.comments}
                    </span>
                  </Link>
                </li>

                <li
                  className={`slide ${
                    activeItem === "/messages" ? "active" : ""
                  }`}
                >
                  <Link
                    data-interaction="messages_menu"
                    to={"/messages"}
                    className={`side-menu__item ${
                      activeItem === "/messages" ? "active" : ""
                    }`}
                    onClick={() => handleItemClick("/messages")}
                  >
                    <span className="side-menu__icon">
                      <i className="ri-chat-1-line"></i>
                    </span>
                    <span className="side-menu__label">
                      {languageData.body.menu.messages}
                    </span>
                  </Link>
                </li>

                <li className={`slide ${activeItem === "/" ? "active" : ""}`}>
                  <Link
                    data-interaction="dashbord_menu"
                    to={"/"}
                    className={`side-menu__item ${
                      activeItem === "/" ? "active" : ""
                    }`}
                    onClick={() => handleItemClick("/")}
                  >
                    <span className="side-menu__icon">
                      <i className="bx bx-desktop"></i>
                    </span>
                    <span className="side-menu__label">
                      {languageData.body.menu.dashboard}
                    </span>
                  </Link>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </aside>
      <OfferModal
        show={showOfferModal}
        onClose={() => setShowOfferModal(false)}
        title={introOffer?.name || ""}
        name={
          introOffer?.rewards
            ?.map((r) => r.packages?.map((p) => p.name))
            .flat() || []
        }
        service={introServices.map(getServiceOfferLabel)}
        description={introOffer?.description}
        date_end={introOffer?.date_end}
        offerId={introOffer?.id}
        reward={introOffer?.rewards || []}
        onOfferTaken={fetchOffer}
      />
      {offers?.map((offer) => (
        <SpecialOfferModal
          key={offer.id}
          /*show={showSpecialofferModal}
         onClose={() => setShowSpecialOfferModal(false)} */
          /*  show={showSpecialofferModal}
          onClose={handleCloseOffer} */
          show={!!openOffers[offer.id]}
          // offer={offers[currentOfferIndex]}
          offer={offer}
          offerId={offer.id}
          name={offer.name || ""}
          price={
            offer.items?.flatMap((item) =>
              item.packages?.flatMap((pkg) => pkg.items?.map((it) => it.price)),
            ) || []
          }
          currency={
            offer.items?.flatMap((item) =>
              item.packages?.flatMap((pkg) =>
                pkg.items?.map((it) => it.currency),
              ),
            ) || []
          }
          discount={offer.items?.map((item) => item.discounts?.value) || []}
          description={offer.description}
          date_end={offer.date_end}
          onClose={() => handleCloseOffer(offer.id)}
          onReject={() => handleRejectOffer(offer)}
        />
      ))}

      {/* Spinner Overlay */}
      {loading && (
        <div className="spinner-overlay">
          <Spinner />
        </div>
      )}
    </>
  );
};

export default Header;
